export var group = function group(contents) {
  return {
    type: 'group',
    contents: contents
  };
};
export var ifBreak = function ifBreak(breakContents, flatContents) {
  return {
    type: 'if-break',
    breakContents: breakContents,
    flatContents: flatContents
  };
};
export var newLine = function newLine() {
  return {
    type: 'new-line'
  };
};